import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const KEY = "kaiya_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, variant, quantity = 1) => {
    setItems((cur) => {
      const idx = cur.findIndex((i) => i.product_id === product.id && i.variant === variant);
      if (idx > -1) {
        const next = [...cur];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + quantity };
        return next;
      }
      return [...cur, {
        product_id: product.id,
        slug: product.slug,
        name: product.name,
        image: product.images?.[0] || "",
        unit_price: product.price,
        variant,
        quantity,
      }];
    });
    setOpen(true);
  };

  const updateQty = (idx, qty) => setItems((cur) => {
    const next = [...cur];
    if (qty <= 0) next.splice(idx, 1);
    else next[idx] = { ...next[idx], quantity: qty };
    return next;
  });

  const remove = (idx) => setItems((cur) => cur.filter((_, i) => i !== idx));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.unit_price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  const value = useMemo(
    () => ({ items, add, updateQty, remove, clear, subtotal, count, open, setOpen }),
    [items, subtotal, count, open]
  );

  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
